import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingComponentProps {
  minHeight?: string | number;
}

export const LoadingComponent: React.FC<LoadingComponentProps> = ({ minHeight = '400px' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: minHeight,
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingComponent;
